import {combineReducers} from 'redux';

import jsonapi from 'aauth/ducks/jsonapi';


export default combineReducers({jsonapi});

